//created by sudip
import { ReactNode } from "react";
import { motion } from "framer-motion";

interface BrowserShellProps {
    children: ReactNode;
}

export function BrowserShell({
    children,
}: BrowserShellProps) {

    return (

        <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.8,
            }}
            className="
                relative
                overflow-hidden
                rounded-[32px]
                border
                border-slate-200/80
                bg-white/95
                shadow-[0_35px_90px_rgba(15,23,42,0.16)]
                backdrop-blur-xl
                h-[780px]
            "
        >

            {/* Browser Header */}

            <div className="flex h-14 items-center border-b border-slate-100 bg-white/90 px-5">

                <div className="flex gap-2">

                    <span className="h-3 w-3 rounded-full bg-red-400" />

                    <span className="h-3 w-3 rounded-full bg-amber-400" />

                    <span className="h-3 w-3 rounded-full bg-emerald-400" />

                </div>

                <div className="mx-auto w-[240px] rounded-full bg-slate-100 px-4 py-1 text-center text-[11px] font-medium text-slate-500">

                    platform.vibewell.live

                </div>

            </div>

            {children}

        </motion.div>

    );

}